import { actionTypes } from '../actions/user';

const ACTION_HANDLERS = {
  [actionTypes.USER_STATUS]: (state, action) => ({ user: action.payload }),
  [actionTypes.USER_STATUS_OK]: (state, action) => ({ user: action.payload }),
  [actionTypes.USER_STATUS_KO]: (state, action) => ({ user: action.payload }),
};

const initialState = null;
export default function loadingReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
